export function setUserInfo(data) {
  localStorage.setItem('userinfo', JSON.stringify(data));
}

export function getUserInfo() {
  const str = localStorage.getItem('userinfo');
  return str ? JSON.parse(str) : null;
}

export function removeUserInfo() {
  localStorage.removeItem('userinfo');
}